// extracted by mini-css-extract-plugin
export default {"area":"SearchArea_area__+at93"};